import React, { useState, useEffect } from 'react';
import { fetchIDsbyTaxonThreshold, fetchIDsbySmartQuery } from './api';
import Search from "./widgets/Search";
import Alert from './alertComponent';
import QuestionMark from './widgets/questionMarkButton';
import Slider from './widgets/Slider';
import { useTheme } from '../theme/ThemeContext';
import CloseIconBlack from '../static/images/black_icons/x_icon_black.png';
import CloseIconWhite from '../static/images/x_icon.png';


const SearchBox = ({ scatterplot, ids, setSelectedIcon, setHighlightTaxon }) => {
    const [searchQuerySmart, setSearchQuerySmart] = useState(null);
    const [searchQueryAdvanced, setSearchQueryAdvanced] = useState(null);
    const [taxonIds, setTaxonIds] = useState([]);
    const [searchType, setSearchType] = useState('smart');
    const [smartSearchTrigger, setSmartSearchTrigger] = useState(0);
    const [advancedSearchTrigger, setAdvancedSearchTrigger] = useState(0);
    const [thresholdCount, setThresholdCount] = useState(50);
    const [selectedSliderIndex, setSelectedSliderIndex] = useState(2); // index for 50 in [1, 10, 50, 100, 200, 500, 1000]
    const [showSlider, setShowSlider] = useState(false);
    const { theme } = useTheme();
    const CloseIcon = theme.name === 'light' ? CloseIconBlack : CloseIconWhite

    const thresholdRange = [1, 10, 50, 100, 200, 500, 1000, 5000];

    const searchBoxStyle = {
        margin: '20px',
        padding: '20px',
        width: '350px',
        color: '#dadada',
        fontFamily: 'Arial',
        backgroundColor: theme.colors.overlay,
        borderRadius: '10px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        transition: 'all 0.3s ease-in-out',
        overflow: 'display',
        width: '450px',
    };

    const closeIconStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '20px',
        height: '20px',
        cursor: 'pointer',
    };

    useEffect(() => {
        const fetchData = async () => {
            if (searchQuerySmart) {
                try {
                    let idsData = await fetchIDsbyTaxonThreshold(searchQuerySmart, thresholdCount);

                    if (!idsData || !idsData.run_assembly_ids || idsData.run_assembly_ids.length === 0) {
                        if (scatterplot) {
                            scatterplot.deselect();
                        }
                        // idsData = await fetchIDsbyTaxonThreshold(searchQuerySmart, 1);
                    }
                    if (idsData) {
                        setHighlightTaxon(searchQuerySmart)
                        setShowSlider(true); // Show slider after successful search
                    }

                    setTaxonIds(idsData.run_assembly_ids);

                    <Alert message={"test"} duration={1000} />;
                } catch (err) {
                    console.log(err);
                    setTaxonIds([]);
                    setShowSlider(false);
                }
            }
        };

        fetchData();
    }, [searchQuerySmart, smartSearchTrigger, thresholdCount]);

    useEffect(() => {
        const fetchData = async () => {
            if (searchQueryAdvanced) {
                try {
                    const idsData = await fetchIDsbySmartQuery(searchQueryAdvanced);
                    setTaxonIds(idsData.run_assembly_ids);
                } catch (err) {
                    setTaxonIds([]);
                }
            }
        };

        fetchData();
    }, [searchQueryAdvanced, advancedSearchTrigger]);



    const handleSmartSearch = (query) => {
        console.log('searching taxon:', query);
        setSearchQuerySmart(query);
        setSmartSearchTrigger(prev => prev + 1)
    };

    const handleAdvancedSearch = (query) => {
        console.log('searching taxon:', query);
        setSearchQueryAdvanced(query);
        setAdvancedSearchTrigger(prev => prev + 1)
    }

    const handleThresholdChange = (newThreshold) => {
        console.log('threshold changed to:', newThreshold);
        setThresholdCount(newThreshold);
        const newIndex = thresholdRange.indexOf(newThreshold);
        if (newIndex !== -1) {
            setSelectedSliderIndex(newIndex);
        }
    };

    useEffect(() => {
        if (taxonIds.length > 0 && scatterplot) {
            const indexes = taxonIds.map((id) => ids.flat().indexOf(id));
            scatterplot.select(indexes);
        }
    }, [taxonIds, ids, scatterplot]);

    return (
        <div style={searchBoxStyle}>
            <img
                src={CloseIcon}
                alt="Close"
                style={closeIconStyle}
                onClick={() => setSelectedIcon(null)}
            />

            <div style={{
                paddingTop: "20px",
                fontSize: '1.8rem',
                fontFamily: 'Arial',
                fontWeight: 'bold',
            }}>
                <span
                    style={{
                        color: searchType === 'smart' ? theme.colors.text : '#888888',
                        cursor: 'pointer',
                    }}
                    onClick={() => setSearchType('smart')}
                >
                    Smart
                </span>
                <span style={{ color: '#888888' }}> / </span>
                <span
                    style={{
                        color: searchType === 'advanced' ? theme.colors.text : '#888888',
                        cursor: 'pointer',
                    }}
                    onClick={() => setSearchType('advanced')}
                >
                    Advanced
                </span>
                <span style={{ color: theme.colors.text }}> search </span>
                <QuestionMark
                    infoSection="selection"
                    disabled={false}
                    title="Search Info"
                    style={{ borderRadius: '50%' }}
                />
            </div>
            <br />

            {searchType === 'advanced' && <Search placeholder={"Advanced search..."} onSearch={handleAdvancedSearch} suggestionsAllowed={false} />}
            {searchType === 'smart' && (
                <>
                    <Search placeholder={"Smart search..."} onSearch={handleSmartSearch} suggestionsAllowed={true} />
                    {showSlider && (
                        <div style={{ marginTop: '20px' }}>
                            <Slider
                                selectedIndex={selectedSliderIndex}
                                onChange={handleThresholdChange}
                                range={thresholdRange}
                            />
                        </div>
                    )}
                </>
            )}

        </div>
    );
}

export default SearchBox;